"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmptySetMetadata = buildEmptySetMetadata;
function buildEmptySetMetadata() {
    return new Set();
}
//# sourceMappingURL=buildEmptySetMetadata.js.map